<template>
  <v-app
    id="inspire"
    class="simple"
  >
    <v-content>
      <header class="flex">
        <router-link :to="{ name: 'login' }">
          <img src="../../public/logo_valacon.svg">
        </router-link>
        <v-btn
          v-if="$route.name == 'register'"
          :to="{ name: 'login' }"
          dark
          color="secondary"
        >
          {{ $t('message.login_form_title') }}
        </v-btn>
      </header>
      <v-container grid-list-md>
        <v-flex
          sm12
          class="header-image"
        >
          <div />
        </v-flex>
        <slot />
      </v-container>
    </v-content>
    <v-dialog
      v-model="showCookiePolicyDialog"
      width="95%"
    >
      <v-card>
        <v-card-title><h1>Cookies</h1></v-card-title>
        <v-card-text id="cookiePolicyContainer">
          <p>Deze website maakt gebruik van cookies. Door deze gegevens te analyseren,
            kan de website nog beter op bezoekers worden afgestemd. De verzamelde gegevens
            worden niet voor een ander doel gebruikt of aan derden ter beschikking gesteld.
            Voor de opslag van deze gegevens maakt de website gebruik van cookies, logfiles
            en javascriptcodes op de pagina’s. Het gaat om de volgende gegevens:</p>

          <p><b>Functionele cookies:</b> Om onze websites goed te laten werken.<br>
            <b>Analytische cookies:</b> Voor het verzamelen en analyseren van statistieken
            om de ervaring op deze website te verbeteren.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="showCookiePolicyDialog=false">Sluiten</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <cookie-law theme="base" buttonText="Akkoord">
      <div slot="message">
        Deze website gebruikt cookies om uw ervaring op onze website te verbeteren.
        Wanneer u op akkoord klikt, geeft u toestemming om al onze cookies te plaatsen.
        <a @click="showCookiePolicyDialog=true">Lees meer</a>
      </div>
    </cookie-law>
  </v-app>
</template>

<script>
import CookieLaw from 'vue-cookie-law'
export default {
    components: {
      CookieLaw
    },
    data: () => ({
      showCookiePolicyDialog: false
    })
}
</script>
<style lang="less" src="../styles/landing.less"></style>
<style scoped>
#app.simple {
  margin-top: 0;
}
.container.grid-list-md {
  margin-bottom: 40px;
}
</style>
<style>
.Cookie__content {
  font-size: 16px;
}
.Cookie.Cookie--base {
  z-index: 100;
}
.Cookie.Cookie--base .Cookie__button {
  background-color: #74af27;
  font-size: 14px;
  font-weight: bold;
}
#cookiePolicyContainer {
  font-size: 16px;
}
</style>
